<template>
    <CardContent title="SmartLog">
        <template v-slot:breadcumb>
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <router-link :to="'/'">
                        <i class="feather icon-home"></i>
                    </router-link>
                </li>
                <li class="breadcrumb-item">
                    <router-link to="/smartlog">SmartLog</router-link>
                </li>
                <li class="breadcrumb-item active">Bookmark</li>
            </ol>
        </template>

        <template v-slot:action>
            <div class="row align-items-center justify-content-between">
                <div class="col mb-1">
                    <div class="d-flex justify-content-start">
                        <button type="button" class="btn btn-outline-primary" style="margin-left: 4px;"
                            data-toggle="modal" data-target="#filterModal">
                            Filter
                        </button>

                        <div class="dropdown" style="margin-left: 4px;">
                            <button class="btn btn-outline-primary" type="button" id="dropdownSortButton"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Sort by
                            </button>
                            <div class="dropdown-menu" style="min-width: 230px;" aria-labelledby="dropdownSortButton">
                                <a class="dropdown-item d-flex justify-content-between" href="#"
                                    @click.prevent="sortBy('created_at', 'desc')">
                                    Terbaru
                                    <span v-if="currentSort == 'created_at' && currentSortDir == 'desc'">✔</span>
                                </a>
                                <a class="dropdown-item d-flex justify-content-between" href="#"
                                    @click.prevent="sortBy('created_at', 'asc')">
                                    Terdahulu
                                    <span v-if="currentSort == 'created_at' && currentSortDir == 'asc'">✔</span>
                                </a>
                                <a class="dropdown-item d-flex justify-content-between" href="#"
                                    @click.prevent="sortBy('name', 'asc')">
                                    Nama Material A-Z
                                    <span v-if="currentSort == 'name' && currentSortDir == 'asc'">✔</span>
                                </a>
                                <a class="dropdown-item d-flex justify-content-between" href="#"
                                    @click.prevent="sortBy('name', 'desc')">
                                    Nama Material Z-A
                                    <span class="mr-2" v-if="currentSort == 'name' && currentSortDir == 'desc'">✔</span>
                                </a>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="col-12 col-sm-4 mb-1">
                    <div class="d-flex justify-content-start align-items-center">
                        <router-link to="/smartlog" class="btn btn-secondary mr-2">Kembali</router-link>
                        <SearchInput v-model="search" placeholder="Cari" />
                    </div>
                </div>
            </div>
        </template>

        <template v-slot:content>
            <div v-if="materials.data?.length == 0">
                <h5 class="text-center text-primary">Data not found!</h5>
            </div>

            <div class="row" v-if="materials.data?.length > 0">
                <div class="col-md-4 col-sm-6 col-12 mb-1" v-for="(item, key) in materials.data" :key="key">
                    <MaterialCard :item="item" @bookmark="saveBookmark" @destroy="destroy" :useAction="false"/>
                </div>
            </div>

            <div class="row d-flex justify-content-center">
                <PaginateList :data="materials" />
            </div>

            <!-- modal filter -->
            <div class="modal fade" id="filterModal" tabindex="-1" role="dialog" aria-labelledby="filterModalLabel"
                aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header modal-primary">
                            <h5 class="modal-title" id="filterModalLabel">Filter</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="">Sub Kategori</label>
                                        <multiselect v-model="selectedSubCategories" :options="sub_categories"
                                            :multiple="true" placeholder="Select" selected-label="✔" select-label="✔"
                                            deselect-label="✖" label="name" track-by="id" :close-on-select="false"
                                            @input="filters.sub_category_ids = selectedSubCategories.map(item => item.id)">
                                            <!-- Slot untuk mengganti tampilan yang muncul di input -->
                                            <template #selection="{ values }">
                                                <span v-if="values.length > 0" class="multiselect__single">
                                                    {{ values.length }} selected
                                                </span>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="">UPP</label>
                                        <multiselect v-model="selectedUnits" :options="units" :multiple="true"
                                            placeholder="Select" select-label="✔" deselect-label="✖" label="name"
                                            track-by="id" :close-on-select="false"
                                            @input="filters.unit_ids = selectedUnits.map(item => item.id)">
                                            <!-- Slot untuk mengganti tampilan yang muncul di input -->
                                            <template #selection="{ values }">
                                                <span v-if="values.length > 0" class="multiselect__single">
                                                    {{ values.length }} selected
                                                </span>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="formSelectGuadang">Gudang</label>
                                        <multiselect v-model="selectedWarehouses" :options="gudangs" :multiple="true"
                                            placeholder="Select" select-label="✔" deselect-label="✖" label="name"
                                            track-by="id" :close-on-select="false"
                                            @input="filters.warehouse_ids = selectedWarehouses.map(item => item.id)">
                                            <!-- Slot untuk mengganti tampilan yang muncul di input -->
                                            <template #selection="{ values }">
                                                <span v-if="values.length > 0" class="multiselect__single">
                                                    {{ values.length }} selected
                                                </span>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="formSelectKategoriMaterial">Kategori Material</label>
                                        <multiselect v-model="filters.material_categories"
                                            :options="['PDP', 'Non PDP', 'ATTB']" :multiple="true" placeholder="Select"
                                            select-label="✔" deselect-label="✖" :close-on-select="false">
                                            <!-- Slot untuk mengganti tampilan yang muncul di input -->
                                            <template #selection="{ values }">
                                                <span v-if="values.length > 0" class="multiselect__single">
                                                    {{ values.length }} selected
                                                </span>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" data-dismiss="modal" class="btn btn-outline-primary" @click="resetFilters">Reset</button>
                            <button type="button" data-dismiss="modal" class="btn btn-primary" @click.prevent="getList">Simpan</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- modal filter end -->

        </template>

    </CardContent>
</template>


<script>
import PaginateList from '@/components/PaginateList.vue'
import SearchInput from '@/components/SearchInput.vue'
import CardContent from '@/components/CardContent.vue'
import MaterialCard from '../material/MaterialCard.vue'

export default {
    name: 'SmartlogIndex',
    components: {
        PaginateList, SearchInput, CardContent, MaterialCard
    },
    data() {
        return {
            selectedUnits: [],
            selectedSubCategories: [],
            selectedWarehouses: [],
            materials: [],
            gudangs: [],
            sub_categories: [],
            categories: [],
            units: [],
            search: null,
            filters: {
                sub_category_ids: [],
                warehouse_ids: [],
                unit_ids: [],
                material_categories: [],
            },
            tab_category: '',
            currentSort: 'created_at',
            currentSortDir: 'desc',
            currentPage: 1,
        }
    },
    mounted() {
        let _ = this
        _.getList()
        _.getUnit()
        _.getGudang()
        _.getSubCategory()
        _.getCategory()
        // Listen for pagination events
        _.$root.$on("paginate", (data) => {
            console.log(data);
            _.getList(data)
        });
        window.$('[data-toggle="tooltip"]').tooltip();
    },
    beforeDestroy() {
        this.$root.$off("paginate");
        window.$('[data-toggle="tooltip"]').tooltip();
    },
    beforeCreate() {
        window.$('[data-toggle="tooltip"]').tooltip('dispose');
    },
    methods: {
        resetFilters() {
            this.selectedSubCategories = [];
            this.selectedUnits = [];
            this.selectedWarehouses = [];
            this.filters = {
                sub_category_ids: [],
                warehouse_ids: [],
                unit_ids: [],
                material_categories: [],
            };
            this.getList();
        },
        getList(page) {
            let _ = this
            if (page) {
                _.currentPage = page // update currentPage jika ada argumen
            }
            _.axios.get('/materials', {
                params: {
                    page: _.currentPage,
                    search: _.search,
                    sort: _.currentSortDir,
                    orderby: _.currentSort,
                    category_id: _.tab_category,
                    is_bookmark: 1,
                    ..._.filters,
                }
            })
                .then(resp => {
                    const dataFetch = resp.data.data
                    // kalau data kosong dan bukan halaman 1, geser ke halaman sebelumnya
                    if ((dataFetch.data?.length === 0 || dataFetch.length === 0) && _.currentPage > 1) {
                        _.currentPage--
                        _.getList(_.currentPage)
                        return
                    }
                    _.materials = dataFetch
                })
                .catch(err => { // jika masih error, gunakan data dummy
                    console.log(err.response)
                })
        },
        getGudang() {
            let _ = this
            _.axios.get('/warehouses?unit_ids=')
                .then(resp => {
                    _.gudangs = resp.data.data
                })
                .catch(err => {
                    console.log(err.response)
                })
        },
        selectCategory(id) {
            let _ = this
            _.tab_category = id
            _.getSubCategory()
        },
        getSubCategory() {
            let _ = this
            _.axios.get('/categories', {
                params: {
                    parent_id: _.tab_category
                }
            })
                .then(resp => {
                    let all_category = resp.data.data
                    _.sub_categories = all_category.filter(item => item.parent_id !== 0);
                })
                .catch(err => {
                    console.log(err.response)
                })
        },
        getCategory() {
            let _ = this
            _.axios.get('/categories?parent_id=0')
                .then(resp => {
                    _.categories = resp.data.data
                })
                .catch(err => {
                    console.log(err.response)
                })
        },
        getUnit() {
            let _ = this
            _.axios.get('/unit')
                .then(resp => {
                    _.units = resp.data.data.data
                })
                .catch(err => {
                    console.log("gagal", err.response)
                })
        },
        saveBookmark(item) {
            let _ = this
            const url = item.is_bookmark ? '/materials/unbookmark' : '/materials/bookmark'
            _.axios.post(url, { material_id: [item.id] })
                .then(resp => {
                    _.$toast.success(item.is_bookmark ? "Data dihapus dari bookmark" : "Data ditambahkan ke bookmark")
                    _.getList()
                    return resp
                })
                .catch(err => {
                    _.$toast.error("Oops terjadi kesalahan")
                    console.log(err.response)
                })
        },
        destroy(item) {
            let _ = this
            this.$swal.fire({
                title: 'Hapus Data Ini?',
                text: "Anda mungkin tidak akan mengembalikannya lagi!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#44A8BD',
                cancelButtonColor: '#D95E6A',
                confirmButtonText: 'Ya, Hapus!',
                cancelButtonText: 'Batal'
            }).then((result) => {
                if (result.value) {
                    _.axios.delete('/materials/' + item.id, {
                        data: {
                            can_manage: item.can_manage
                        }
                    })
                        .then(resp => {
                            _.$toast.success('Data Berhasil dihapus')
                            _.getList()
                            return resp
                        })
                        .catch(err => {
                            console.log(err.response)
                            _.$toast.error('Oops! terjadi kesalahan')
                        })
                } else {
                    _.$toast.info("Data tidak dihapus")
                }
            })
        },
        sortBy(orderBy, sortDir) {
            this.currentSort = orderBy;
            this.currentSortDir = sortDir;
            this.getList()
        }
    },
    watch: {
        search: function () {
            console.log("berfungsi")
            this.getList()
        },
        tab_category: function (newVal) {
            console.log("tab_category changed to: ", newVal)
            this.selectedSubCategories = []
            this.filters.sub_category_ids = []
            this.getList()
        },
    }
}
</script>